import React from "react";
import { useLocation, Navigate, Outlet } from "react-router-dom";
import { routingData } from "./routing";

// ─────────────────────────────────────────────────────────────
//  RedirectRouter.jsx — UPDATED for DPR role-based redirect
//
//  WHAT CHANGED from your original:
//  - Now reads "dpr_role" from sessionStorage
//  - Matches against routingData by dpr_role
//  - Redirects user to their role's defaultRoute on login
//
//  Flow:
//  1. User logs in via HRMS → HRMS sets access_token in sessionStorage
//  2. DPR calls /api/dpr/my-role/ → gets dpr_role
//  3. dpr_role stored in sessionStorage as "dpr_role"
//  4. This component redirects them to the right defaultRoute
// ─────────────────────────────────────────────────────────────

const RedirectRouter = () => {
  const location = useLocation();
  const dpr_role = sessionStorage.getItem("dpr_role");     // e.g. "super_admin"
  const token    = sessionStorage.getItem("access_token"); // existing HRMS token

  // not logged in → let login page render
  if (!token || !dpr_role) {
    return <Outlet />;
  }

  // find the routing block that matches this dpr_role
  const roleObject = routingData.find((e) => e.role === dpr_role);

  if (roleObject) {
    return (
      <Navigate
        to={roleObject.defaultRoute}
        state={{ from: location }}
        replace
      />
    );
  }

  // dpr_role doesn't match anything in routingData → unauthorized
  return <Navigate to="unauthorized" state={{ from: location }} replace />;
};

export default RedirectRouter;